import { useQuery } from "@tanstack/react-query";
import api from "../../services/api";

export const useViewAppOpenCount = () => {
    return useQuery({
        queryKey: ['viewAppOpenCount'],
        queryFn: async () => {
            const res = await api.get('/reports/distributor-users-view-count');
            return res.data?.data;
        }
    });
}; 
